import { Badge, Button, Card, Tabs } from "antd";
import React, { useState } from "react";
import styled from "@emotion/styled";
import { RightOutlined } from "@ant-design/icons";

// eslint-disable-next-line no-empty-pattern
const MessageCenterStyled = styled("div")(({ }) => ({
  //   background: "#f3f8fa",
  // height: "100vh",
  // background: "var(--color-bg)",
  boxShadow:
    //  "0px 2px 4px #bfbfbf;",
    "0 1px 2px -2px #e4e4e429,0 1px 2px -2px #0000001f,0 1px 2px -2px #00000017",
  ".header": {
    // background: `url('${headerBg}') no-repeat center/cover`,
    ".adm-image-img": {
      height: "47px",
      width: "auto",
    },
  },
  ".ant-tabs-nav": {
    // padding: "0px 24px",
    background: "linear-gradient(to bottom, #eef0ff, #f6f7ff)",
    ".ant-btn": {
      background: "transparent",
      fontSize: "12px",
    },
    ".ant-tabs-ink-bar": {
      width: "28px !important",
      marginLeft: "24px",
    },
    ".ant-tabs-tab": {
      paddingLeft: "24px",
      paddingRight: "24px",
      margin: "0px",
    },
    ".ant-tabs-tab-active": {
      background: "#fff",
      borderRadius: "4px",
    },
  },
  ".ant-tabs-content": {
    height: "293px",
  },
  ".taskItem:nth-child(3n+1)": {
    backgroundColor: "#FFF7F3",
    borderLeft: "4px solid #FF915A",
  },

  ".taskItem:nth-child(3n+2)": {
    backgroundColor: "#F6FBFB",
    borderLeft: "4px solid #70DBD1",
  },
  ".taskItem:nth-child(3n+3)": {
    backgroundColor: "#F7F7FC",
    borderLeft: "4px solid #3D4CAF",
  },
  ".taskItem": {
    borderRadius: "8px",
    padding: "16px 10px",
    marginBottom: "15px",
    borderRight: "20px solid #C4D9EF",
    cursor: "pointer",
    ":hover": {
      boxShadow:
        "0 1px 2px -2px #e4e4e429, 0 1px 2px -2px #0000001f, 0 1px 11px 6px #00000017",
    },
    ".title": {
      fontSize: "15px",
      color: "#333",
      width: "100%",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      // fontWeight: "bold",
    },
    ".taskItemInfo": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      ".infoItem": {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        fontSize: "11px",
        color: `#8C8C8C`,
        width: "30%",
        minWidth: "70px",
        marginRight: " 3px",
        "span:last-child": {
          maxWidth: "calc(100% - 56px)",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
      },
    },
  },
  ".anticon-right": {
    position: "relative",
    right: "-27px",
    top: "-12px",
    svg: {
      color: window.sui_primary_color || "#074d93",
    },
  },
  ".ant-badge": {
    position: "relative",
    right: "-18px",
    top: "-30px",
  },
  ".ant-scroll-number": {
    borderRadius: "4px",
    fontSize: "12px",
  },
}));
// 修复：将 data 改为通过 props 获取
const Content = ({ data = [] }) => {
  console.log(data, "data");

  return (
    <div className="px-6 py-2 pb-5">
      {data?.slice(0, 3)?.map((it, index) => {
        return (
          <div
            key={index}
            className="taskItem"
            onClick={() => {
              window.open(it?.url);
            }}
          >
            <div className="text-base title">{it.title}</div>
            <div className="taskItemInfo">
              <div className="from infoItem">
                <span>来源：</span>
                <span>{it.applyOrgName}</span>
              </div>
              <div className="creater infoItem">
                <span>申请人：</span>
                <span>{it.applyName}</span>
              </div>
              <div className="createTime infoItem">
                <span>创建时间：</span>
                <span>{it.applyTime}</span>
              </div>

              {it.emergency && <Badge count={"紧急"}></Badge>}
              <RightOutlined />
            </div>
          </div>
        );
      })}
    </div>
  );
};

const App = ({ msg, chatInstance }) => {
  const [types, setTypes] = useState([
    {
      title: "待办",
      api: "todotask",
      data: [
        {
          delegateLoginName: null,
          mobileProcessTraceUrl: null,
          backToFirstAct: false,
          appCode: "eos",
          mobileDoneUrl: null,
          source: null,
          deadLine: null,
          notShow: false,
          subTitle: null,
          appId: 5,
          doneUrl:
            "http://bkd.sudytech.cn/default/base/workflow/preview.jsp?mode=preview&processInstId=404&currworkItemID=448",
          id: 56,
          state: 0,
          applyTime: "2024-11-15 13:00:12",
          userRead: false,
          createTimeStr: "2024-11-15 13:00:16",
          processTrace: false,
          taskBizId: "448",
          planStartTime: "2024-11-15T13:00:16.000+08:00",
          delegateName: null,
          receiveDate: "2024-11-15T13:00:16.000+08:00",
          weight: 0,
          sort: 50,
          createrName: "教职工测试1",
          suspendDate: null,
          processTraceUrl:
            "http://bkd.sudytech.cn/default/base/process/process.jsp?processInstId=404",
          creater: {
            loginName: "999001",
            name: "教职工测试1",
            id: 4,
          },
          collect: false,
          processNodeName: "主管校领导审签",
          taskCategory: null,
          cancelDate: null,
          importance: 0,
          notDeadSearch: false,
          readTime: null,
          title: "教职工测试1副处级以上教职工请假申请",
          delegate: false,
          processCurrentTask: null,
          toppingTime: null,
          processTraceUsedTime: "89天20小时35分钟",
          mobileUrl: null,
          applyName: "教职工测试1",
          topping: false,
          urgent: 0,
          collectTime: null,
          tag1: null,
          appName: "eos",
          backTask: false,
          monitor: false,
          tag2: null,
          url: "http://bkd.sudytech.cn/default/base/workflow/do.jsp?workItemID=448",
          deadLineStr: null,
          participantExpandUsers: null,
          tag3: null,
          applyOrgName: "网络安全与信息中心",
          usedTime: "89天20小时35分钟",
          application: null,
          createTime: "2024-11-15T13:00:16.000+08:00",
          myChildTaskUrl: null,
          circulation: false,
          processNodeId: "zgxld",
          userDone: false,
          applyDate: "2024-11-15T13:00:12.000+08:00",
          category: null,
          applyLoginName: "999001",
          stopDate: null,
        },
        {
          delegateLoginName: null,
          mobileProcessTraceUrl: null,
          backToFirstAct: false,
          appCode: "eos",
          mobileDoneUrl: null,
          source: null,
          deadLine: null,
          notShow: false,
          subTitle: null,
          appId: 5,
          doneUrl:
            "http://bkd.sudytech.cn/default/base/workflow/preview.jsp?mode=preview&processInstId=341&currworkItemID=383",
          id: 27,
          state: 0,
          applyTime: "2024-07-04 13:38:56",
          userRead: true,
          createTimeStr: "2024-07-04 13:41:00",
          processTrace: false,
          taskBizId: "383",
          planStartTime: "2024-07-04T13:41:00.000+08:00",
          delegateName: null,
          receiveDate: "2024-07-04T13:41:00.000+08:00",
          weight: 0,
          sort: 50,
          createrName: "教职工测试1",
          suspendDate: null,
          processTraceUrl:
            "http://bkd.sudytech.cn/default/base/process/process.jsp?processInstId=341",
          creater: {
            loginName: "999001",
            name: "教职工测试1",
            id: 4,
          },
          collect: false,
          processNodeName: "系统管理员2审核",
          taskCategory: null,
          cancelDate: null,
          importance: 0,
          notDeadSearch: false,
          readTime: null,
          title: "2024-07-04教职工测试1VPN、堡垒机申请",
          delegate: false,
          processCurrentTask: null,
          toppingTime: null,
          processTraceUsedTime: "223天19小时57分钟",
          mobileUrl: null,
          applyName: "教职工测试1",
          topping: false,
          urgent: 0,
          collectTime: null,
          tag1: null,
          appName: "eos",
          backTask: false,
          monitor: false,
          tag2: null,
          url: "http://bkd.sudytech.cn/default/base/workflow/do.jsp?workItemID=383",
          deadLineStr: null,
          participantExpandUsers: null,
          tag3: null,
          applyOrgName: "网络安全与信息中心",
          usedTime: "223天19小时54分钟",
          application: null,
          createTime: "2024-07-04T13:41:00.000+08:00",
          myChildTaskUrl: null,
          circulation: false,
          processNodeId: "xtgly2sh",
          userDone: false,
          applyDate: "2024-07-04T13:38:56.000+08:00",
          category: null,
          applyLoginName: "999001",
          stopDate: null,
        },
      ],
      // data: [
      //   {
      //     title: "陈露虚拟机申请",
      //     origin: "网上办事大厅",
      //     applicant: "陈露",
      //     createTime: "2023/10/14",
      //     emergency: true,
      //   },
      //   {
      //     title: "陈露校外媒体采访登记审批",
      //     origin: "网上办事大厅",
      //     applicant: "陈露",
      //     createTime: "2023/10/14",
      //     emergency: true,
      //   },
      //   {
      //     title: "陈露虚拟机申请",
      //     origin: "网上办事大厅",
      //     applicant: "陈露",
      //     createTime: "2023/10/14",
      //   },
      // ],
    },
  ]);
  const [activeKey, setActiveKey] = useState < any > (0);

  return (
    <MessageCenterStyled className="card-container">
      <div>
        <Tabs
          // type="card"
          tabBarExtraContent={
            <Button
              className="mr-6 bg-transparent"
              type="primary"
              ghost
              size="small"
              onClick={() => {
                window.open(
                  `http://bkd.sudytech.cn/#/work?tabIndex=${activeKey}`
                );
              }}
            >
              查看全部
            </Button>
          }
          items={types?.map((item, index) => ({
            label: item.title,
            key: index,
            children: <Content data={item.data || []} />,
          }))}
          activeKey={activeKey}
          onChange={(key) => setActiveKey(key)}
        />
      </div>
    </MessageCenterStyled>
  );
};

export default App;
